export default function SarapeDivider({ className = "" }) {
  return <div aria-hidden="true" className={`sarape h-1 w-full opacity-80 ${className}`} />;
}
